
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `Wyczyść`,
'deleteKey': `Usuń`,
'downKey': `↓ W dół`,
'endKey': `⤓ Koniec`,
'enterKey': `Enter`,
'escapeKey': `Ucieczka`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Wygenerować 
          <code>LICENCJA 
          </code> plik 
        `,
'homeKey': `⤒ Strona główna`,
'keyCommand': `Polecenie/Win`,
'keyControl': `Kontrola`,
'keyOption': `Opcja/Alt`,
'keyShift': `⇧ Shift`,
'leftKey': `← Lewa`,
'pagedownKey': `Pagedown`,
'pageupKey': `▲ Pageup`,
'rightKey': `→ Prawo`,
's00065e45db8c0441': `Aby uzyskać więcej informacji, zobacz narzędzia deweloperskie`,
's001dd78415a91fa0': `Rynna paska przewijania`,
's002fa7d1054ed082': `Ramka graniczna`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kazachstan`,
's01b56d233c6c5cac': `Sekcjonowanie`,
's01d32b35baa3b676': `Autor`,
's02106cc2ef0e7578': `Nowy pin...`,
's02ab1ea8e5100fc1': `Oznacz wybór jako "nadpisanie dwukierunkowe".`,
's0312976fe9da5951': `Przycisk`,
's03608a32f05eded2': `Powiększenie przez uszczypnięcie`,
's036d35e03be98d22': `Głębokość matematyczna`,
's037b1dc850a89273': `Alternatywnie pod`,
's0396202b716732ec': `Oznacz wybór jako przekreślony`,
's03f49e598ffb11cc': `Polski`,
's0448f1059fa01720': `Zapisywanie, udostępnianie lub drukowanie eksploracji. Edytuj informacje, takie jak tytuł, język lub licencja.`,
's0458872c43beadef': `Wstaw wiersz przed`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Odstępy między wyrazami`,
's05e9759cfd99c48f': `Uzasadnienie`,
's063fa5a0a4903bf4': `Na boki, od lewej do prawej`,
's064339c229374050': `Kodowanie`,
's06634274f19b0572': `Wybór pinów`,
's06743b24499f0035': `Centrum kotwiczenia`,
's07808b0ca6da8fef': `Ogrodzona strona internetowa`,
's07970793b21351fd': `Podstawowy kontener Ruby`,
's079cf7850d9327f0': `Czcionka`,
's07aa10850d9ddcc7': `Formularz`,
's07e6118e838b2e23': `Nawigacja`,
's0816468df86e4036': `Otwiera ustawienia`,
's082869038c117fe5': `portugalski (Brazylia)`,
's086e6c267ade2609': `Nasycenie`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Audio`,
's0978fb5ba3145996': `Wstaw listę (nieuporządkowaną)`,
's09c3f1d21de14ae1': `Zaznacz zaznaczenie jako podkreślone`,
's0a2d91c6720033e9': `Odstępy między tekstami`,
's0a3ddcba94027d95': `Dopasowanie obiektu`,
's0a6cb8d42cdb0c4a': `Esperanto`,
's0a799f583098cadf': `Wstawianie nawigacji`,
's0a7db790db1fc45c': `Oznacz zaznaczenie jako zakres`,
's0b1271f50a77dc73': `Zawartość pudełka`,
's0b24d08ea349b455': `Wszystko, co można wstawić. Na początku znajdują się elementy nieinteraktywne, takie jak listy lub obrazy, a następnie elementy interaktywne zwane widżetami. Nowe elementy można uzyskać, klikając pasek wyszukiwania.`,
's0b7ae9543c001867': `Odpowiedź`,
's0bdca49248ba4820': `Skróty`,
's0befccf152b6c0a9': `Orient z metadanych`,
's0c11e479416c8421': `Wstaw podpis tabeli`,
's0c27336067c59611': `Wypełnienie przewijania`,
's0c4593d81f147042': `Linia bazowa`,
's0c4b2e98d4ab7f5a': `Polecenia aplikacji`,
's0c883713b83616a8': `Zapisywanie aktywnego dokumentu`,
's0ca5c0460199cba1': `Skrót`,
's0cf10c4f40588f8d': `Podpis pod tabelą`,
's0d86afa3c6a1e28b': `Elastyczny kierunek`,
's0dad143dff0079fc': `Malajalam`,
's0db05bd7ba6fff96': `Dokument do eksploracji. Tutaj możesz pisać tekst, kopiować/wklejać, edytować itp.`,
's0dc07f97c821463c': `Wybór komentarzy`,
's0dc452999c129e15': `Włącz przeładowanie na żywo`,
's0de0febab8a4beaf': `Błąd odczytu tego pakietu`,
's0e44968489e076a8': `Chiński`,
's0e4862e87c7d53ce': `Oznacz wybór jako cytat`,
's0e6ea8870dbddab2': `Polecenia dokumentu`,
's0ee28503778e4c0c': `Ostatni poziom bazowy`,
's0ef01c03299bbb83': `Dekoracja`,
's0f17f32919661cff': `Mongolski`,
's0f350bc4e538e3ea': `Słowa`,
's105540b7756c0232': `Termin definicji`,
's105a06836c40fcb4': `Ustawianie filtrów, kolorów i mieszania wybranych elementów`,
's106b274b5af798e5': `Zdania`,
's1082e1649793dca9': `Oznacz wybór jako zdefiniowany termin`,
's10f3845975a0351e': `Edycja metadanych`,
's1125d159f7e64df5': `Wyświetlacz`,
's11326fd2590f4e5e': `Domyślne`,
's1155ec07a221e739': `Pasek przewijania`,
's1173bf7a3e0b74c9': `Minimum (y)`,
's1177237a3e0e548c': `Minimum (x)`,
's1219d97b49650c05': `Widoczność`,
's123bea44f38abccf': `Wstaw obiekt`,
's1245e2cb9f20197e': `Wyrównaj`,
's12946ec1b850962c': `Wstaw kolumnę po`,
's1351209ef74ee729': `Rozmieść wszystkie kolumny`,
's13c60cb409e8cb6f': `Wyrównaj środek`,
's13ebd619c8a06a6d': `Automatyczne wiersze siatki`,
's13ef8ca26ca8861b': `Cięty element`,
's151349210ac1d2d8': `Wstaw grupę`,
's151bc2eea7a032a4': `-unchanged-`,
's153bc3c3aa39587b': `Głowica stołu`,
's156647179b21d351': `Wstaw treść tabeli`,
's158b6ec6b1fffcb2': `Przerwa po`,
's15d0c0657c1ee08c': `Klucz API`,
's1626a7e10a9f9dcc': `Ustawia rodzinę czcionki zaznaczenia`,
's1637c7d1a30629e2': `Ramka graniczna`,
's1641ab440bf4daa4': `Zaktualizuj ten pakiet widżetów`,
's166bd56d19670a72': `Zoom`,
's1696c76a23c0834e': `Zaawansowane: Pokaż pakiety z wersjami takimi jak 0.x.x w menedżerze pakietów`,
's16b9446e3a70e1f4': `Atrybuty`,
's16f205466761e583': `Brak optycznego rozmiaru czcionki`,
's16f2f1c2c516d307': `Otwórz dokument`,
's1749014f3f87fa6a': `Rozciągnięcie`,
's17597a8bb4810524': `Licencja`,
's17bfaaa4e7528bc7': `Baszkir`,
's17fb3f4805f4f4b9': `Usuń pole`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Utwórz pakiet`,
's18d5c44aae3dc82a': `Online podczas edycji`,
's1988d71ef8060edf': `Wstaw wiersz tabeli`,
's19abee1277c9bca2': `Samoańczyk`,
's19daf2f26c19543d': `Zarys`,
's1a1acc902e6668e0': `Pokaż zaawansowane formatowanie tekstu`,
's1a5230a71d9285c1': `Przechwytywanie`,
's1aa1cb63ad44bc6f': `Odstęp między kolumnami`,
's1af8b67d1c85c811': `Przestrzeń między`,
's1b4a36fce2456660': `Rodzina czcionek`,
's1c246045629b0016': `Oznacz zaznaczenie jako usunięcie`,
's1c3fc313a9184670': `Łącze publiczne`,
's1c65f5004a07dcfa': `Szkocki gaelicki`,
's1c690963f1e2df00': `Wygląd specyficzny dla platformy`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Chcesz krótką wycieczkę z przewodnikiem?`,
's1d19244f549ec535': `Edukacja`,
's1d5c7b28e8b50d6d': `Stopień stowarzyszony.`,
's1db591f5a54dbfd3': `Content Box`,
's1dbb9f50e16c92a3': `Promień graniczny`,
's1dfb744260fb3a01': `Izolacja dwukierunkowa`,
's1e9c2c654732cc5f': `Białoruski`,
's1eaccbf2d6af8ab5': `Informacje`,
's1efbfc3937d565bd': `Kontekst`,
's1f2b49c1bca2035d': `Kataloński`,
's1f74bdf32b51a5fc': `Obraz tła`,
's1f7698c061c208c9': `Otwarty`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Korsykanin`,
's21d61916eb8d137d': `Korpus stołu`,
's21d723a1dbcd89c8': `Jawajski`,
's21f8a2eaf5a70749': `Wstaw etykietę`,
's2206c42e5b835e6e': `Oznacz wybór jako skrót`,
's22a2348c46a912a0': `Wstaw sekcję`,
's233ae776268cd44b': `Biznes`,
's236ed7ba747099b0': `Waga czcionki`,
's2474e7fb1aec9f05': `Test`,
's2492f5fb1b05b45e': `Tekst`,
's24949d7adbb5a098': `Zestaw narzędzi`,
's252a52330d32b900': `Metadane`,
's2540844a4bc4d9ba': `Wymagać przypisania?`,
's255857544a9d5ec0': `Reset`,
's255c77900f2b5e0f': `Schemat kolorów`,
's256ab831a48c941c': `Usuwa całe formatowanie tekstu z zaznaczenia`,
's2591806d7b222591': `Resetowanie zmian`,
's25e1a07e454c2c11': `Siatka`,
's262abbaf1d05f009': `Miękkie światło`,
's266935f2447fcd98': `Over Left`,
's268ecd1cef45a9a8': `Jesteś pewien?`,
's2692bc028fed91f1': `Caps Lock`,
's27056379e0acfdb0': `Rozjaśnić`,
's27076e66c5d483ba': `Wyrównanie w pionie`,
's2712dc5641a33226': `Konta rejestru pakietów są przeznaczone dla deweloperów i umożliwiają
          skonfigurowanie jednego lub większej liczby rejestrów`,
's2739460e44320108': `Chiński (tradycyjny)`,
's27cc88818cc46ff6': `Stabilny`,
's281d957112b10f12': `Bezpośrednia edycja kodu HTML dokumentu`,
's28b6246ce616a548': `Wstaw grupę kolumn tabeli`,
's29a1c26521879b9f': `Skalowanie w dół`,
's29acfd2778e8c377': `Ukryj zaawansowane formatowanie tekstu`,
's29b24c06315e9343': `Wstawianie wejścia`,
's29eb103449472e3b': `Wstaw nagłówek (poziom 3)`,
's29ee7434494a0dfe': `Wstaw nagłówek (poziom 2)`,
's29f21c34494d614d': `Wstaw nagłówek (poziom 1)`,
's29fbfc3449557f72': `Wstaw nagłówek (poziom 6)`,
's29ff743449588131': `Wstaw nagłówek (poziom 5)`,
's2a031834495bcdb4': `Wstaw nagłówek (poziom 4)`,
's2a75c946ef4dcab7': `Różne`,
's2b2ae20d26f78ac2': `Blok`,
's2b8f50c64be440f7': str`Wybór 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Zamówienie`,
's2bad2d24def4aa0b': `Podział wiersza (język CJK)`,
's2ceb11be2290bb1b': `Anuluj`,
's2ced8e8fafb499f6': `Usuń element`,
's2d986d31f8d67357': `Wstaw zestaw pól`,
's2d995a37cf5e4995': `Wstaw NoScript`,
's2de969afacdaa7a6': `Kształt`,
's2df075aface0dab8': `Udział`,
's2e192b19ed15fcf6': `Strona`,
's2e39b99cf23606fa': `Ustaw układ wybranych elementów`,
's2e4818861000b13f': `Układ`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Przepełnienie (y)`,
's2edd6688a65e21f0': `Przepełnienie (x)`,
's2f0bcdffc92a786b': `Pływanie w prawo`,
's2f2044f2431a32d5': `Nagłówek`,
's2f4d4bfbc466d91f': `Albański`,
's2f8da2cb5f236588': `Nazwa pakietu. Musi mieć zakres, np. \`@org/pkg\`. `,
's30cce87854901922': `Przedszkole`,
's3124653c272f054c': `Kolor reguły kolumny`,
's314a4f7685c8e824': `Zawsze`,
's31c06e226322f065': `Unikaj sierot`,
's323dcde72b850272': `Dostęp publiczny`,
's32911e52ee8ac745': `Wstaw gniazdo`,
's337a1e9022a8d19f': `Tabela`,
's33c1450d2822bb0f': `Wstaw podpis rysunku`,
's33c18d5a4cbffa2a': `Irlandczyk`,
's33f85f24c0f5f008': `Zapisz`,
's342b0cabfa672822': `Pomóż użytkownikowi znaleźć widżet`,
's3437e0d9899e7ae1': `Wysyłanie danych telemetrycznych dotyczących korzystania z WebWriter.`,
's344ea8f4939cdc98': `Kolor`,
's34dcda3b0f9d5a98': `Przełącz adres url`,
's34f724979a124c50': `Ustawia kolor tła zaznaczonego tekstu`,
's355b21b89ce5d9c5': `Szczegóły`,
's35ae5f4e0fa2777b': `Niestandardowe wyrównanie`,
's35aeaff1425bca9e': `WebWriter nie obsługuje nośników typu `,
's35c3125c7750681e': `Blockquote`,
's3643189d1abbb7f4': `Kod`,
's3649bacefe731bf6': `Przełączanie przybornika`,
's365280e16a8ea32d': `Kopiowanie zaznaczenia`,
's366991b9c9287765': `Prawo`,
's36a194e38d653a26': `Adnotacja danych`,
's36b3cefdcb897f15': `Perspektywa`,
's372fae706048ce41': `Even-odd`,
's377e24af9628c37e': `Zamówiona lista`,
's37a8c35f6581da5f': `Brak kotwicy`,
's37fa3b9cd51c2dfd': `Ustawia rozmiar czcionki zaznaczenia`,
's380d17664bb69531': `Wstaw kolumnę przed`,
's3815184eb09f0dcf': `Kursor`,
's382a2aa3984474dd': `Utwórz`,
's38980f98cb07ceb8': `Zapisz aktywny dokument jako kopię`,
's3914cb410fca44d4': `Import`,
's3a179f6db2972384': `Pozycja Ruby`,
's3a5ca02f282d247e': `Udostępnij...`,
's3ae67088bbefba98': `Pakiety`,
's3b0ab4b52326316f': `Światło`,
's3bc203a3f8a6409c': `Aktualizacja języka w całym dokumencie`,
's3bdad99768e11911': `Eksplorowalny`,
's3cb47df8290fa94c': `Wstaw opcję`,
's3cf89cb47fdde7e9': `Link`,
's3d09398e555ee5f9': `Opcje zaawansowane`,
's3d249bb480032121': `Lista`,
's3d3efd1e19bdcfb4': `Adnotacja daty/godziny`,
's3d6a732c792ccb9e': `Adnotacja Ruby`,
's3d93f9ea0c5a13fa': `Obraz`,
's3d9548e211b958ce': `Pomiń nakładanie się`,
's3e092e9d1ee2c5bb': `Klip`,
's3e78ddc9a48a608d': `Ładny`,
's3eb6d1e6e79ed7c4': `Nie znaleziono żadnych dokumentów`,
's3eca5a034978754b': `Usuń zaznaczenie`,
's3f06e9abb6ebcb79': `Postacie`,
's3f1e7a3f2b283d3b': `Margines`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gudżarati`,
's3f7e097a9b2e6181': `Wstaw artykuł`,
's3fd83566dd643d10': `Wstaw legendę`,
's3fe72792941c18f9': `Tekst na dole`,
's3ffcdc5db5e7d0c5': `Odwrócony`,
's40e3826b7f74a3b5': `Pan (po prawej)`,
's40f07d7859284a44': `Dominująca linia bazowa`,
's4101ada154a1b958': `Środek`,
's410c465a5993f82d': `Możliwość przerwania linii`,
's41322d19c928c603': `ICT`,
's417b90913e05bc17': `Podgląd`,
's418f2020fe996832': `Potwierdź zmiany`,
's41c724f0698148e9': `Oznacz zaznaczenie jako skrót klawiaturowy`,
's41f65a763f8e44ab': `Grupa nagłówków tabeli`,
's42721130228841b0': `Skrzynka udarowa`,
's429bd646f1cf8bc6': `Konta Grammar LLM umożliwiają korzystanie z interfejsu API Grammar LLM do poprawiania gramatyki w tekście.`,
's429dd933ba95549b': `Wstaw adres`,
's42e470ef1d707a28': `Autoodtwarzanie`,
's42ffdab1291fb3de': `Wstaw wiersz po`,
's430831017f3f0499': `Skos (y)`,
's430bd5017f42511c': `Skos (x)`,
's433ba70286202ceb': `Przerwać wszystko`,
's441b20a8a50e36b4': `Macedoński`,
's445b8acb9206db6e': `Odrzuć i anuluj`,
's446a924922651ea0': `Podkreślenie tekstu`,
's44cdba92713de38e': `Obszar siatki`,
's45518abd911471d0': `Chorwacki`,
's456a8d744313852a': `Przestrzeń wokół`,
's4634541f5056a546': `Abchaski`,
's46d4abe6255cb9e1': `Ponowne przypisanie skrótu`,
's4730c232e7209c40': `Przytnij oba`,
's474f0eec369d02a4': `Przykładowe wyjście`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `Oznaczenie wyboru jako adnotacji daty/godziny`,
's47ebf3a8fb3b10c1': `Orientacja`,
's4802bb8eb52fbdeb': `Portal`,
's4802e47fe2e95134': `Opcja`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Cień tekstu`,
's4993444bfd3f3e5e': `Upadek`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Maska`,
's49dd67aed00029ef': `Matematyka`,
's49e763aed00877a8': `Główny`,
's4a894f57eba1cf1e': `Skrót klawiaturowy`,
's4ac1ad6ecd6bd810': `Misc. ed.`,
's4ad6e9d3c2365c98': `Twarde światło`,
's4b2c143acf931122': `Wysokość linii`,
's4b58c01e2578f5e4': `Legenda`,
's4bbff4e008690da1': `Unikaj strony`,
's4c402ff5355fd310': `Zastąpienie dwukierunkowe`,
's4caed5b7a7e5d89b': `Angielski`,
's4cb38675a21b2c98': `Nieobsługiwany typ właściwości "\${desc.type}" (przetwarzanie jako JSON)`,
's4cc8391f172c0cdf': `Opuścić wycieczkę`,
's4ce8cc041a628847': `Po zmianie języka dokumentu należy odpowiednio zaktualizować języki wszystkich widżetów.`,
's4d528b416ac8dee2': `Wstawianie grupy nagłówków`,
's4d546f6c87128d5b': `Najpierw przestrzeń`,
's4dcb9315f6527f9c': `Uruchom przy ponownym ładowaniu`,
's4e191bdb4700a6e9': `Overscroll (x)`,
's4e1c7fdb470386ac': `Overscroll (y)`,
's4e2562fe3990e621': `Błąd połączenia`,
's4e361bf8eef3759a': `Przerwa na słowo`,
's4ea0f21fc2a338a1': `Przesuń w górę`,
's4eace13b3ed74187': `Komentarz z boku`,
's4efee5b48a4593cb': `Pętla`,
's4f26e7cb7c0a8318': `Rysunek wektorowy`,
's4fd2e638aabb0bb3': `WebWriter obsługuje osadzanie wielu różnych źródeł. Wystarczy wkleić link do treści
          z:`,
's4fda04cbc245e18b': `Alpha`,
's4ffac3fb33a2ee9b': `Tajski`,
's5015a8fb33b98872': `Cienki`,
's50489ffb1bde152e': `Wstawianie`,
's5068560b8d39663d': `Mapa z możliwością kliknięcia`,
's517acbf1f96324f9': `Waga`,
's523eb9043213ff0d': `Kursywa`,
's52777d434baeed9b': `Wstaw wskaźnik postępu`,
's52af5d7ac34c2163': `Wiersz tabeli`,
's52e0bdc3ee304436': `Włóż miernik`,
's52fb1524cb25d7ab': `Nowy wątek`,
's531056f039febd39': `Wstaw zaznaczenie`,
's536695196d0b6dc3': `Faeroese`,
's542fcefa0bbaed86': `Otwieranie lub zamykanie przybornika (tylko na wąskich ekranach, w przeciwnym razie przybornik jest zawsze widoczny z boku).`,
's5432ad3c84273229': `Rysunek`,
's543906d1db8b2283': `Edytuj `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Kambodżański`,
's54897f2764b0e4d0': `Zainstaluj ten pakiet widżetów`,
's54cbfaf2a8da7818': `Paszto`,
's550839f3e4e205bb': `Zaznacz wybór jako bardzo ważny`,
's55905c735052d295': `Przerwa tematyczna`,
's5590dbf7e425789d': `Etykieta`,
's5623aa2f83b05c76': `Tybetański`,
's564d1648b1ceee9f': `Aktualny`,
's565cd5ffb0158c46': `Unikaj regionu`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Wróć`,
's5787c6d5b3b5541a': `Ścieżka klipu`,
's579c69f419b6caef': `Gładki`,
's587ac858dd80f6fa': `Indeks dolny`,
's58bec0ecd4f3ccd4': `Ścisły`,
's59404f5593c32fdc': `Kerning czcionki`,
's5941292bb77281ab': `Norweski Bokmål`,
's599dcd2472c75c19': `Ustęp`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Oznaczenie wyboru adnotacją dotyczącą danych`,
's5a356677b61a6b7e': `Mołdawia`,
's5b474b5c0ac0c7c4': `Grupa kolumn tabeli`,
's5b517ac216f9ee62': `Na boki`,
's5b8cc9bb61ddce15': `Wstaw akapit`,
's5bba2ac2e53bd1fd': `Kirgiz`,
's5be80ad6b8301710': `Inline start`,
's5c1ecf88259b79f9': `Prezentacja`,
's5c2a1a52c0389c30': `Inżynieria`,
's5c63af7695445fcf': `Styl tekstu`,
's5d18ca4c3111be6f': `Wstaw nagłówek tabeli`,
's5d87c1e588f48d90': `Praktyka`,
's5d929ff1619ac0c9': `Wyszukiwanie`,
's5da52af9b083c29a': `Model`,
's5dc77784260a7236': `auto`,
's5e27738a2e8eb763': `Zaloguj się`,
's5e2cba97c0d971bd': `Przeładowanie pakietów`,
's5e53415a6d5719ad': `Nauki społeczne`,
's5e6a7a0c30d2a270': `Pomiń nakładanie się (auto)`,
's5e9e8e4d21bafedc': `Produkcja żywności`,
's5ed03bb1f3a15949': `Zdjęcie`,
's5f43af3669b1e098': `Źródło`,
's5feaf7fd7ee567c8': `Przerwać słowo`,
's600fd23c9ce971e8': `Drukowanie aktywnego dokumentu`,
's602bbd28dae2c60f': `Samodzielne uruchamianie`,
's60ff598dfcf2c773': `Pod prawem`,
's61053f0e3ebbd272': `normalny`,
's613c6ff83883c04f': `Kolumna tabeli`,
's6196153c4b0c1ea0': `Instalacja`,
's61c017f6d5c303af': `Fryzyjski`,
's61ded17ca3f48c82': `Przesunięcie podkreślenia`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Wybór kopiowania`,
's624e31cd4f1b89d4': `Płynne przewijanie`,
's626daf42b1ab7df7': `Wyrównaj do lewej`,
's6280bf993915c57a': `Margines przewijania`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Opis`,
's63dfc5b1c1c27849': `Jidysz`,
's63e03c70f67ebf9c': `Kontekst`,
's63e71d20d1eaca93': `Niemiecki`,
's640bc7710d0143ce': `Ponawia ostatnią cofniętą zmianę w aktywnym dokumencie`,
's64dc1fc7e3db45c9': `Tworzenie nowego dokumentu`,
's65ac276544ba33cd': `Plik SVG`,
's66765c420ee578e4': `Przestrzeń równomiernie`,
's669b18c6d2d9c95b': `Brak`,
's6747dbf4ad6063ba': `Self end`,
's6787497df07fa97e': `Może przewijać przystanki`,
's67c2b60a506a09e4': `Drugie wydanie.`,
's680bd4d926cd5a84': `Preserve 3D`,
's6827930ef1aeaf99': `Podstawowy adres URL`,
's684a16f3c711394d': `Over Right`,
's687e27f036a71b32': `Izolować`,
's68b87d7b61052dc3': `Wiersz tabeli`,
's68e0e3a2bab7ce3e': `Unikaj`,
's690da6b432987c6f': `Automatycznie tworzy kopię zapasową zmian w bieżącym dokumencie. Zmiany są przywracane po ponownym załadowaniu WebWriter.`,
's69311c4e25074fb3': `Szkoła średnia`,
's697400b541fbc3cd': `Pod`,
's6988ab5d47593a26': `Masz najnowszą wersję WebWriter.`,
's69a49786a8009f43': `Znajdź pakiety...`,
's69b12144dbb6544d': `Laotański`,
's69d88ef4b2618980': `Okładka`,
's69fbbdb8ad2a084a': `Ciemność`,
's6a31eff1ec4f71ad': `Ukryj backface (3D)`,
's6ac62e1c8c66f3bb': `Kompaktowy superscr.`,
's6b585ba37cdb8260': `Dziedziczenie`,
's6b61f8abf89586be': `Hebrajski`,
's6bd7a02fdf93e653': `Wyrównanie zawartości`,
's6cfc66b824ea05ba': `Ostre krawędzie`,
's6d02dc19e21eb49c': `Top`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Wietnamski`,
's6d8b3b8047ed378d': `Tryb mieszania`,
's6d8c02aee480af7a': `Menu`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Wstawianie stylu`,
's6e288a119281f4c2': `Renderowanie tekstu`,
's6e4c20c6debcd5ca': `Niestandardowe uzasadnienie`,
's6f84199e62584905': `Wstępnie sformatowany tekst`,
's6fb3053e7244d326': `Inne pola`,
's70178e04a3b691b6': `Ustawienia otwarte`,
's7031ca562378bde6': `Precyzja geometryczna`,
's7060970b5ed20a58': `Interaktywność`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Pokaż niestabilne pakiety`,
's71dec51005acc1e4': `Gęsty rząd`,
's72f2a02e2a5a4ee3': `Media`,
's730182ad28374cda': `Obiekt`,
's731678e227a20559': `To urządzenie`,
's736904f276fbd441': `Nauki przyrodnicze`,
's739544d0c858c633': str`Lub upuść 
          ${0} tutaj 
        `,
's73cb20c838e761e1': `Wybór cięcia`,
's7417792bbe720149': `Redo`,
's741fae02b3dd24f3': `Rozpikselowany`,
's743f778233e42a3f': `Na marginesie`,
's744d993d03f29851': `Ekran`,
's74540c1b595a229c': `Formuła TeX`,
's748c0074eff45884': `Manipulacja`,
's74aa0039a87141e2': `Elipsa`,
's74b9781bacfcc87c': `Pendżabski`,
's74cd20a7aece9b91': `Pole wypełnienia`,
's75109f5307578a61': `Witamy w WebWriter`,
's75a27f43413e02c5': `Francuski`,
's75d83fc3f0cfab40': `Nagłówek`,
's762e5704cc84089d': `Ustaw inne opcje stylu wybranych elementów`,
's77318393dfdb0775': `Usuń wiersz`,
's77e594ddcc10c774': `Zezwolić na użytek komercyjny?`,
's780099588362f80f': `Pozycja definicji`,
's782eac2b3e80323d': `Oznacz wybór jako podkreślony`,
's782f286a79cca35d': `Względny`,
's78673a3539cb1915': `U góry po lewej`,
's78789724e789221c': `Rozmiar`,
's789ff24c8f03f1a4': `Odstępy między literami`,
's7995733bf97c01cc': `Serbsko-chorwacki`,
's7a99528e7b64635a': `Oksytański`,
's7aaf0c06e69600f1': `Błąd z `,
's7ae49e142487766c': `Dostęp do społeczności`,
's7af555180b30a947': `Otwórz narzędzia deweloperskie`,
's7b4ba250601b8667': `Wstawianie szablonu`,
's7b560d8693ed8f42': `Pionowo`,
's7b9994904c4f5b54': `Tadżyk`,
's7bdf0fd5b014d36c': `Duże znaczenie`,
's7beb1e77e82363eb': `Cofnięcie ostatniej zmiany w aktywnym dokumencie`,
's7c61118554a0ec36': `Maksimum (x)`,
's7c95876637f6a9d7': `Filtr`,
's7cb4e55c59663b1c': `Firma`,
's7cfe12cd14df9950': `Wyloguj się`,
's7d27db3c9639c6dd': `Alternatywny`,
's7d8103f6f06f83d6': `Wypełnienie`,
's7d864465dddbb50d': `Zezwalaj na zmianę rozmiaru`,
's7de0e28d6c309a4e': `Zezwalaj na akcje dotykowe`,
's7dea785045c3cc74': `Naciśnij nową kombinację klawiszy...`,
's7e0b179d4d1414eb': `Wprowadź łącze`,
's7e6570f2f1ae320f': `Synteza krojów pisma`,
's7ecb1f29332293e5': `Linia bazowa wyrównania`,
's7ed13ccddb1bf3c3': `Nakładka`,
's7edbe0b213199995': `Licencjat`,
's7ede1c55e35ce9d6': `Symulacja`,
's7f09197a4814079b': `Ustawianie opcji interaktywności dla wybranych elementów`,
's7f326a142e856656': `Styl`,
's7fcb35d23be1e643': `Zestaw pól`,
's80570196a9ce6d11': `Włącz telemetrię`,
's806f84eb0ace116e': `Zobacz, co wybrałeś i zmień to. Kopiowanie, wycinanie, wklejanie, przypinanie lub wprowadzanie zmian w układzie. Oferuje różne opcje w zależności od zaznaczenia, np. formatowanie tekstu.`,
's80a42b81c52d4d8f': `Kolor karetki`,
's80b71fc6f43c5ce1': `Luźny`,
's812cbda653daaeba': `Ta funkcja nie została jeszcze zaimplementowana`,
's81c3d8809658b951': `Kaszmir`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Kontynuuj`,
's8247d32213e35f24': `Wstaw główny`,
's82665b2ffabc9c0a': `Strona internetowa`,
's828b1ecea8715884': `Patelnia (lewa)`,
's833bd0422a7ef95d': `Rozmiar zakładki`,
's83420ad7b6a14db5': `Przełącz narzędzia deweloperskie`,
's83c15613b6f6f3c8': `Tylko online`,
's83cd32b685ccc9b7': `Elementy sterujące`,
's83f26d02dd7aa681': `Widoczny`,
's840fa49e8989c028': `Pozycja/kształt`,
's844a76d1843ceb3c': `Przywróć ustawienia domyślne`,
's84e4e8ae645b82ac': `Prawy górny róg (y)`,
's84e9c7f8785ca60b': `Wstaw formularz`,
's8517ae4da104b004': `Grupa kolumn tabeli`,
's85186a61e0d55bac': `Wideo`,
's851a7deea5984646': `Licencja Creative Commons OER?`,
's85f9aa6d3ea0e421': `Grupa stopek tabeli`,
's864b0e6270e97246': `Oznacz wybór jako komentarz poboczny`,
's8670e5ad3bf0dcf8': `Zapisz jako`,
's8688d74dd3716d6e': `Skróty klawiaturowe dla poleceń`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Margines kształtu`,
's87cefc710b3567fb': `Zawierać`,
's88676f992b2965db': `Rozciągnięta zawartość komórki`,
's886897f2fd4edb99': `Ukryty`,
's886c5db2a5579873': `Koncepcja`,
's888c71e8fcb916d3': `Autozapis`,
's88a62d29529948fb': `Wstawianie tabeli`,
's89950d86c8004d4b': `Pomijaj bez nakładania się`,
's89bca7498f20e041': `Klip w tle`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Przerwa przed`,
's8a4ff2bd9c13498c': `Rekord`,
's8a6585c48ea104e9': `Ukryj puste komórki`,
's8a9eb438abac7c6a': `Etykiety`,
's8b0432eecbd8b034': `Aktualizacja`,
's8b7580c35e2aef87': `Lewy górny róg (y)`,
's8bc4affa761aa8a2': `Wstawianie obrazu`,
's8c7f51cb067644c7': `Lista danych`,
's8d342ecaa9e75b9b': `Związek`,
's8d797888455f4147': `Miejsca przerw`,
's8d83386457e91813': `Cofnij/przywróć zmiany lub wyświetl podgląd z perspektywy ucznia.`,
's8d8643013a7754d1': `Wyrównaj tekst`,
's8df30fe2a50d3479': `Możliwość wstawienia podziału wiersza`,
's8e715248c3a78446': `Odetnij wybór`,
's8f29e48d6b9a1aa8': `Wstaw wiersz nagłówka tabeli`,
's8f4be9f086eb530f': `Cofnij`,
's8f533296a536965e': `Zapisz jako...`,
's8fad58c831ecf017': `Kontener tekstowy Ruby`,
's8ffe7abcbed8eb43': `Pionowo, od lewej do prawej`,
's90105521fcc40453': `Konta WebWriter Cloud umożliwiają przechowywanie dokumentów online i udostępnianie
          ich uczniom. Dodaj konto tutaj, a będzie ono dostępne jako lokalizacja do zapisywania,
          ładowania, udostępniania i otwierania dokumentów.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Paleta czcionek`,
's90f7c1cf501ea0a7': `Unikanie kolorów`,
's91093e0b087911ba': `Podkreślenie pozycji`,
's919e1724f589c9b1': `Slot`,
's91c5ed7769d00b65': `Wstaw embed`,
's9219acd5bef6269e': `Pod lewą`,
's92548405912d46bf': `Wyrównanie przyciągania przewijania (y)`,
's9258280591309342': `Wyrównanie przyciągania przewijania (x)`,
's927d796559f49439': `Pochodzenie tła`,
's92b177e579ef7b97': `Podkreślenie`,
's92f846b9be2e8e8d': `Oznacz zaznaczenie jako kursywę`,
's93566b84230af4f5': `Wstawianie obrazu`,
's936aa0b239679585': `Wstaw przerwę tematyczną (zwykle wyświetlaną jako pozioma linia).`,
's9370dc6afa716b57': `Granica`,
's93f083e654a45715': `Bretończyk`,
's94653c76b2d86a04': `Określony termin`,
's9485af2e7cd9418f': `Szkoła podstawowa`,
's94d2eee44b292567': `Przełączanie opcji zaawansowanych`,
's94d61907ee22a8c1': `Koreański`,
's94eb1effbbb6498b': `Przepełnienie`,
's951aa3a6439f1271': `Znacznik listy`,
's9565553d163fc92a': `Skrypt`,
's957787fc6b7ea5c0': `Pan (w górę)`,
's95d56e58f816d211': `Holenderski`,
's95d8e41a64635c7c': `Biała przestrzeń`,
's95de7e1eff6c053e': `Poziomo, od góry do dołu`,
's960d3a90ac199368': `Retoromański`,
's96532132a29dd542': `Wstawianie dźwięku`,
's96a045dcade75ad0': `Gęsta kolumna`,
's9781a5bb3fcb26a3': `Najpierw wybierz firmę`,
's978522fbc9577a7e': `Somalijski`,
's97881699a2b21d5b': `Luka w rzędzie`,
's97aa76056a81bd36': `Metryki`,
's986facb3ecc9602c': `Na boki, od prawej do lewej`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Plik zewnętrzny`,
's98977a87d1b93941': `Resetowanie informacji, stylów i skryptów`,
's98b1cb8fb62909ec': `Grupa`,
's990d0e0fa2ab00b5': `Galicyjski`,
's99229574e5692f19': `Grenlandzki`,
's99a990f3841ad283': `Pliki `,
's99b38e000175cc84': `Przekreślenie`,
's99f110d27e30b289': `Tytuł`,
's9ab10fbf4c7a7322': `Pozycja podkreślenia`,
's9abadcc828884d7b': `Textarea`,
's9b7cd8860c8fc922': str`
          ${0}
          zostanie nadpisana. Czy na pewno? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Kolor tła`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Kolumna tabeli`,
's9cf68f87b8e6122f': `Azerbejdżan`,
's9d167ef77aed79b6': `Warstwa`,
's9d2d00982edafabb': `Turecki`,
's9d430adc5be110e9': `Odwrócony rząd`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Usunięcie`,
's9df571714a1efb44': `Dostępna jest automatycznie zapisana wersja tej eksploracji. Wczytać ją?`,
's9e28faa598332e2b': `Wstaw wideo`,
's9e3dbb678150edd4': `Ustawianie rodziny czcionek`,
's9e40e59654c8ad67': `Kolumna`,
's9e85800d3700e31c': `Ścieżka`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Wariant czcionki`,
's9f1ecdb3061d9cbc': `Zachowanie przestrzeni`,
's9faf26107ed49fb9': `Wstawianie komórki tabeli`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Przejście`,
's9ff3121d30f88d52': `Normalny`,
's9ffe1bbe64712bf1': `Płótno`,
'sa00df4e39c72d3b4': str`
          ${0} nie jest obsługiwany 
        `,
'sa013e119fec906fb': `Rząd`,
'sa01e7bf33563ef72': `Załącznik kontekstowy`,
'sa126cf8c627cec1e': `Renderowanie obrazu`,
'sa13f72278add7513': `Pod prawem`,
'sa1647e3b36ec08d7': `Połączenie w pozycji pionowej`,
'sa172190ea21f9b1c': `Uzyskaj dostęp do ustawień, otwórz eksplorację lub utwórz nową.`,
'sa1c6c459b9b5115c': `Bezwzględny`,
'sa2cba871f6cdd99f': `Assamese`,
'sa2eff4dad1c119f1': `Szablon siatki`,
'sa30c12014e955946': `Rosyjski`,
'sa30f1981fd1cd441': `Rozmiar czcionki`,
'sa311a24c1471a974': `Dokument`,
'sa352d168b262aa06': `Wstaw stopkę`,
'sa37fee6a52d18063': `Usuń dokument`,
'sa39c7ac1d37f3bce': `Oznacz zaznaczenie jako "izolację dwukierunkową".`,
'sa3b4c01623211544': `Siła`,
'sa40fd43756fa8913': `Perski`,
'sa417644bef21a9aa': `Nienazwany motyw`,
'sa43800e28be1bdbc': `Kolor dekoracji`,
'sa477cb1825dceb3b': `Sudańczyk`,
'sa492a51a707930fa': `Wstawianie cytatu blokowego`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Napis na dole`,
'sa50d3c35533f1d99': `Wszystkie pola`,
'sa53c5cb03a8fda50': `Przypnij zaznaczenie jako fragment na palecie`,
'sa557ae6bee9148a6': `Postęp`,
'sa589e1df65dde0ec': `Ustawianie rozmiaru, wypełnienia i marginesów wybranych elementów`,
'sa5c371b4bb75e590': `Lewa`,
'sa5c80e623459ffe4': `Wstaw nagłówek`,
'sa5df1bcdba46c3fb': `Rysunek Napis`,
'sa602e3fd3f2d98fd': `Animacja`,
'sa644d580d8a11e60': `Wyrównanie Ruby`,
'sa645d315510dc09e': `Wybierz ścieżkę z dysku`,
'sa65d4ad99f1d8c06': `Ustawianie tła tekstu`,
'sa6607436f60ccc1a': `Estoński`,
'sa6f8d27bca557059': `Przenieś elementy meta/link/style w górę/w dół do tego elementu`,
'sa757645ad842da97': `Zachowaj przerwy`,
'sa75b95980cd80e78': `Edytor`,
'sa7698b3d20a6d1ec': `Przewijanie`,
'sa778acc33947c7b8': `Zakończenie wycieczki`,
'sa78a67272a4a6f95': `Formuła matematyczna`,
'sa79167651dce1e80': `Tekst alternatywny`,
'sa7af797a46c7d09a': `Stopka tabeli`,
'sa7dbe35b758c138d': `Wstaw kanwę`,
'sa7dc6b8ef3f595dc': `Wstaw źródło`,
'sa8279f8211b3950d': `Zachowanie przerw i przestrzeni`,
'sa8b55cab62e439b5': `Usuń kolumnę`,
'sa8bbe0197d31b423': `Krótki opis`,
'sa9ff3b762365abe6': `Początek transformacji (z)`,
'saa02e3762368ff35': `Początek transformacji (y)`,
'saa065776236bfa28': `Przekształć początek (x)`,
'saa33768e03c45fc8': `Rozmiar pliku`,
'saaad98061a20ac39': `Wstaw formułę matematyczną`,
'saab875d8cfcfe712': `Temat`,
'saad4380b9cc6cefd': `Alternatywnie`,
'saaec15c97a9e4245': `Kolumna odwrócona`,
'sab0c57df694a0a09': `Trim start`,
'sab4d9283896d9422': `Rozdzielczość przyciągania pikseli`,
'sab55faae8e165407': `Wypełnienie&lt;br&gt; jak przerwa`,
'sab5e7d2a069a2951': `Certyfikat zawodowy.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Wyrównaj do prawej`,
'sac895c732f350ac5': `Ciemny`,
'saced41ddda8b2354': `Elastyczna podstawa`,
'sad190f86451081c0': `Nepalski`,
'sad6be321164d08c8': `Kompaktowa matematyka`,
'sadd352cc7f6f2307': `Na bok`,
'sae098810f946ca7c': `Tagalog`,
'sae185e6af80ec81e': `Szwedzki`,
'sae1c7f13b7c0c47f': `Start`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maorysi`,
'sae9d739068eee2c5': `Tatar`,
'saf312eaeec77a802': `Wstaw listę opisów (glosariusz, listę terminów)`,
'saf3da7c95cb17260': `Oznacz zaznaczenie jako indeks górny`,
'saf440a0a592f2835': `Aktualizacja do`,
'saf9e5134ba1a7d30': `Zatrzask przewijania`,
'safc6f203342d09e2': `Przełącza podgląd aktywnego dokumentu`,
'sb0a7e3adf4a125ee': `Prawy górny róg`,
'sb0a974028c99ca6d': `Pozwolić na adaptacje?`,
'sb0d4f0f7993cf085': `Ustaw rozmiar czcionki`,
'sb0f3327210fe18fc': `Kolumny`,
'sb0f93c1c60c0249a': `Rubinowa podstawa`,
'sb1494c08c8c720d1': `Ustawianie koloru tekstu`,
'sb19611adbc88f711': `Zaawansowane: Pokaż polecenia edycji źródła, np. aby wyświetlić kod HTML dokumentu lub dodać niestandardowe style i skrypty.`,
'sb206d700d26b14ff': `Podkreślenie`,
'sb233557012dcb328': `Przesuń w dół`,
'sb26035b596566abf': `Bez nazwy`,
'sb2cda80610c8d6ea': `Przestrzeń dla wszystkich`,
'sb2dc787b0983ebc6': `Litewski`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Centrum`,
'sb3ba3276ae93627c': `Wstaw wstępnie sformatowany blok tekstu`,
'sb430f5b4824de0d3': `Wybierz układ`,
'sb43db07b24da018a': `Amharski`,
'sb45f9fb4dba6e71a': `Nieustawiony`,
'sb4e003a459464d85': `Kurdyjski`,
'sb4f0310e6787d098': `Uzbek`,
'sb4f1dffbb6be6302': `Wyczyść`,
'sb51270e19988f9bd': `Region`,
'sb59d621e3c93cc27': `Współdzielone granice komórek`,
'sb5e9e1776242b028': `Interakcje`,
'sb60bc1250aad44c1': `Rozpiętość`,
'sb60dd9d23d31ee66': `Doktorat`,
'sb6103872073d369e': `Wstaw szczegóły`,
'sb616811735bfbafd': `Komórka tabeli`,
'sb628960829e223bb': `Pomiń wszystkie nakładki`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Zastosuj i importuj`,
'sb66e2181a7b5738a': `Włączając telemetrię, użytkownik zezwala na gromadzenie i przechowywanie danych zgodnie z naszymi`,
'sb67e0e7c0869f982': `Różnica`,
'sb68e83cda6c85af8': `Nagłówek tabeli`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Grubość dekoracji`,
'sb70c17f7899f9b01': `Łacina`,
'sb71941f552f3504d': `Ustaw wartość specjalną`,
'sb740eab4afd5a710': `Automatyczny przepływ siatki`,
'sb741b6e0ca589122': `Warstwa cofania`,
'sb7c77d0415de05cf': `Uruchom testy`,
'sb7fb7568f6883ab8': `Udostępnianie aktywnego dokumentu`,
'sb85774dc5d18ff0f': `Potwierdzenie`,
'sb85b1e36579852a6': `Nieprawidłowy adres e-mail lub hasło`,
'sb884fa76bfc55429': `Arabski`,
'sb8a3d4df7d1c5e6b': `Równowaga`,
'sb8f610a0e8df91fc': `Jasność`,
'sb8f855b49234b81b': `Zastosuj`,
'sb905da066c10182c': `Plus ciemniejszy`,
'sb940ade1bd81be7e': `Pod lewą`,
'sb9e9a7dd45966756': `Oznacz wybór jako pogrubiony`,
'sba509fd8ed61d1d5': `Niezapisany plik`,
'sba64d8954d027206': `Krycie`,
'sba88d90cd6c751b3': `Reguła kolumny`,
'sbaf0a7c417e388af': `Zdrowie`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Filtr tła`,
'sbb85a407d730e13d': `Wstawianie wyszukiwania`,
'sbb86c6c96f598bb8': `Mieszane`,
'sbba0156f795d8c07': `Edytuj wybór`,
'sbba865d4b437944f': `Atrybut`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `Odinstaluj`,
'sbc5f2a81604baf9b': `Pozycja 6`,
'sbc5f2b81604bb14e': `Pozycja 5`,
'sbc5f2c81604bb301': `Pozycja 4`,
'sbc5f2d81604bb4b4': `Pozycja 3`,
'sbc5f2e81604bb667': `Pozycja 2`,
'sbc6953a36ced943f': `polityka prywatności`,
'sbd181cd54b8402a4': `Edycja wyboru`,
'sbd35ee879d9cf770': `Tekst Ruby`,
'sbd40f40cbadd38d5': `Usuń ten pakiet widżetów`,
'sbd72dc858de95ce8': `Birmański`,
'sbe3c60c65f129daa': `Nauki humanistyczne`,
'sbe4a7c8f231739b3': `lub wklej/upuść/wybierz plik`,
'sbe90de083557ef3e': `Suahili`,
'sbefb6064cba01844': `Wstaw podział wiersza`,
'sbf00e1ee999ea94e': `Wstawianie skryptu`,
'sbf519920c2017d67': `Wiszący`,
'sbfa01f189a68d3e9': `Elastyczny wzrost`,
'sbff54e740c4086eb': `Pokaż nieznane pakiety`,
'sbfff51feacf30196': `Sanskryt`,
'sc0ceaa9843510f67': `Turkmen`,
'sc1611c0558728a2a': `Pozycja`,
'sc1a155cc25899250': `Grupa wierszy tabeli`,
'sc1aa1f6051b7102a': `Rumuński`,
'sc1edebeaef92b7bd': `Stały układ tabeli`,
'sc1fff4f356dfb2fb': `Przekształcenie`,
'sc221faca1ecb4aee': `Anonimowy`,
'sc24bda3c061fddf8': `Klikalny obszar`,
'sc252a4e091763606': `Wstaw stopkę tabeli`,
'sc2536e077514accc': `Przewijanie`,
'sc275dd00036d16cb': `Charakter cytatów`,
'sc28864200d2a3799': `Skopiuj kod QR jako obraz`,
'sc2a24a9dd41a9503': `Linia dekoracyjna`,
'sc2b734cca2fa643b': `Pan (w dół)`,
'sc2e2a0dbf03723b7': `Zaawansowane: Pokaż pakiety z nieznanych źródeł w menedżerze pakietów (Ostrzeżenie: może być niebezpieczne)`,
'sc3998b77d72c2932': `Wstaw stronę internetową (jako ramkę wbudowaną)`,
'sc3ac225273c8316b': `Ogólne`,
'sc3cfee84dbbf36ae': `Plik lokalny`,
'sc3f09a9b6fa4fbed': `Wewnątrz`,
'sc43767deea72e9f3': `Lista opisów`,
'sc462bbdd36bcba6b': `Skrzynka referencyjna`,
'sc4ee3e4ee994dafd': `Ukraiński`,
'sc50d09edf9325339': `Dialog`,
'sc52b67794c06a0d3': `Początek perspektywy (y)`,
'sc52e8b794c0913d6': `Początek perspektywy (x)`,
'sc53de149fcaad713': `Między postaciami`,
'sc546f489f9c0cced': `Przełącza tryb testowy dla aktywnego dokumentu`,
'sc5bcf50d1b578d9f': `Ustawienia funkcji czcionki`,
'sc5cb39478b9b7625': `Oznacz zaznaczenie jako indeks dolny`,
'sc6415b50ff928294': `Pozycja na liście`,
'sc650ff15b20fe9d3': `Obrót (z)`,
'sc6578b15b2154365': `Obrót (x)`,
'sc65aff15b2183e58': `Obrót (y)`,
'sc6da0f4a7e4d710e': `Nadpisanie języka czcionki`,
'sc74e3567875ce255': `Zarówno tag widżetu, jak i nazwa pakietu NPM.`,
'sc7eb080b96e244df': `Malajski`,
'sc8ac7ef92b95df3f': `Move (x)`,
'sc8af536e2084ade0': `Paleta`,
'sc8b022f92b992bc2': `Przesunięcie (y)`,
'sc8b39af92b9c2d81': `Przesunięcie (z)`,
'sc8d2c7f6c33a2b32': `Ustawianie stylu tekstu (wyrównanie, wcięcie, odstępy itp.) wybranych elementów`,
'sc8fa0e3de389ef1c': `Dostosowanie rozmiaru czcionki`,
'sc9474bf7a0668d73': `Podsumowanie`,
'sc94e314312a8900c': `Czechy`,
'sc980855a000b76ea': `Dół`,
'sc98b103772de63f4': `Fiński`,
'sca7cfe2bef51b2a5': `Korzeń`,
'sca7fed2bef53cb99': `Rola`,
'scabe6ecee5e01fd2': `Maltański`,
'scace301a88231cce': `Osadzony`,
'scbc55f622ec078c1': `View box`,
'scbe537fc38ff4c13': `Automatyczne kolumny siatki`,
'scc1db59d292cbc4c': `Sekcja`,
'scc56b218a2689c42': `Ormiański`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Ramka wyściełająca`,
'scd9cedeb5ece3adb': `Hyphenate`,
'scdf536b65be39ec5': ` Tworzenie/importowanie`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideograficzny`,
'sceecdd0bb404bc17': `Wstawianie grupy opcji`,
'scf00d48fd5953a03': `Grecki`,
'scf932840a69dbb7c': `Portugalski`,
'scf932a8577057752': `Stopka`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Na dole po prawej`,
'sd01178c54f648118': `Kolumny równoważące`,
'sd03bff50f87f82d4': `Znak łącznika`,
'sd05a155fe09c2866': `Online podczas korzystania z`,
'sd0864ea6cb6ef22e': `Wspólnota`,
'sd10fdbe6caf9a998': `Line Break`,
'sd121d3b959b7888d': `Optymalizacja prędkości`,
'sd1a78e667a1a139f': `Oznacz zaznaczenie jako wstawienie`,
'sd1cffad290ea5b3b': `Zachowaj wszystkie`,
'sd1f10284eeb17b25': `Fidżi`,
'sd1f44f1a8bc20e67': `E-mail`,
'sd1f81984eeb7c0e8': `Wypełnienie`,
'sd29dc07235eea0f5': `Cytat`,
'sd2addf69477cd4b4': `Pakiet importowy`,
'sd2ed26defc646d47': `Filtr tła`,
'sd2ef82b8ea877c6d': `Afrikaans`,
'sd319aae1401f1e19': `Naprawiono`,
'sd3a288c1094b8a63': `Szerokość reguły kolumny`,
'sd3c65ef5c380c046': `Wstawka`,
'sd3dcb76f7b28adb8': `Łotewski`,
'sd3eca1e0f4209f6e': `Przytnij wszystko`,
'sd3f402df8619ddcd': `Te informacje o użytkowniku są automatycznie dodawane do nowych dokumentów. Można to
          zmienić dla każdego dokumentu w edytorze metadanych.`,
'sd4368b12645d3c0f': `Wstawianie portalu`,
'sd452cebf4a0313d1': `Pokaż polecenia edycji źródła`,
'sd48cc52117f4d68b': `Włoski`,
'sd52660ee947ca58b': `Wstaw kolumnę tabeli`,
'sd588d17a1b25c220': `Przepełnienie tekstu`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Szkolnictwo wyższe.`,
'sd5cf95145e4d89ca': `Odepnij ten fragment`,
'sd5fd9d11a92f5b1d': `Lewy dolny róg (y)`,
'sd60c9bbc51375635': `Wstawianie przycisku`,
'sd66c4767fa3dde28': `Kolor akcentujący`,
'sd679c8b1bf8cc8a5': `Małe kapitały`,
'sd7086c4425c53c80': `Rodzina czcionek`,
'sd837f42ac7cbfb58': `Kształt (na zewnątrz)`,
'sd88076d2994ee0fb': `Wykluczenie`,
'sd89a2e529b31ef43': `Revert`,
'sd8a345e95668b73b': `Pionowo, od prawej do lewej`,
'sd8ce9e57270b030d': `Rozciąganie czcionki`,
'sd8ecf227c7c49331': `Matematyczny`,
'sd8f923198e0c5c6a': `Koniec`,
'sd9c21e5f60d6bdd8': `Duński`,
'sd9ff8e2612e63d50': `Rozmiar ramki obramowania`,
'sda2d76b976502a8d': `Otwarte...`,
'sda344aacb837387e': `Pozycja w pojemniku`,
'sda5b6fa8b771f996': `Pływak lewy`,
'sda9254d1f1228e1a': `Węgierski`,
'sdb1595f5c742dfbb': `Wejście`,
'sdb711380a28fec75': `Wstaw listę (uporządkowaną)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `Prawy dolny róg (y)`,
'sdc12d4d35420eeb7': `Komentarze`,
'sdc48456f9a27ae02': `Generator`,
'sdc70d81cf6c28533': `Gruziński`,
'sdd1ff479d04ac140': `Publiczny`,
'sdd2fc8919a9c3111': `Tryb mieszania tła`,
'sdd35b688281b6dea': `Japoński`,
'sddc49047f66a64ab': `Brak opisu`,
'sdef34fe08bb28b09': `Chiński (uproszczony)`,
'sdf62e305e1594805': `Oznacz zaznaczenie adnotacją ruby`,
'sdf946172dfa0328f': `Indeks górny`,
'sdf9bc5d9b7f3e3de': `Wyrównanie`,
'se036b53f145441cd': `Zawartość mieszana`,
'se06f459fccdc3ce9': `Wyrównaj ostatni wiersz tekstu`,
'se0a782a8be8e018b': `Norweski`,
'se0cda6b80a1bb50f': `Słowacki`,
'se0f67eae944f8f94': `Wyciszenie`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Artykuł`,
'se1f5bb0386c88f96': `Ustawia kolor zaznaczonego tekstu`,
'se219da7b1e955c65': `Przejrzyste formatowanie`,
'se25e4f2cb77b8be8': `Język dla interfejsu WebWriter i nowych dokumentów`,
'se2796c5824ec8916': `Widoczność treści`,
'se308836a594808b6': `Singhalese`,
'se36c5b1baf5e0660': `Gdziekolwiek`,
'se39c065efa467782': `Baskijski`,
'se3b4c857f91f80d7': `Skróty klawiaturowe`,
'se47baf2fd16b9d2b': `Szablon`,
'se48bd9e6c2a3109d': `Konta`,
'se58467472725ad0c': `Rozdzielczość obrazu`,
'se58f06c2b0583ff7': `Wybierz współrzędne`,
'se5dc1e97fb743ade': `Rozstaw`,
'se619a501d1bfe6a5': `Owijka`,
'se62385ac082368d2': `Oznacz wybór jako źródło cytowania`,
'se6297163cac9d276': `Edytuj źródło`,
'se633223a0b88625e': `Rozmieszczenie komórek`,
'se638417c560cfe5c': `Włamanie do środka`,
'se64f418b4e733b6c': `Wstaw wyjście`,
'se79c0a3ac70d8fb3': `Współczynnik aspiracji (x)`,
'se79fae3ac710dc36': `Współczynnik aspiracji (y)`,
'se7fad370d8fb4cec': `Optymalizacja czytelności`,
'se8a94b4effa2033e': `Alfabetyczny`,
'se95d4e55ea186d9a': `Kolor paska przewijania`,
'se96d43a515b8451c': `Słoweński`,
'se96fd76ba1b2975a': `Centralny`,
'se9ac05f36b004eb0': `Ukryj wycieczkę wprowadzającą. Wyłącz, aby wycieczka została ponownie wyświetlona.`,
'se9b1fec72ffd8f48': `Lokalny`,
'sea24bdcaa2bd2dec': `Obowiązkowe zatrzaśnięcie`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `Przełącza edytor metadanych`,
'sea896ed51ad33287': `Brak dostępnych stylów`,
'seaaaeb09e3b4e78b': `Polecenia edycji`,
'seabae79729c4b2ad': `Przełącz e-mail`,
'seaecc8267bad6234': `Gimnazjum`,
'seaf97719986faf4f': `Gap`,
'seb19675a580f0628': `Unikaj kolumny`,
'seb4e52ef5ec7a7dc': `Kolory/Efekty`,
'seb8982ae8c3cdcc5': `Indonezyjski`,
'sebbced89e0db2894': `Pierwsza linia bazowa`,
'sec02109a0dd2a6c8': `Podkreślenie koloru`,
'sec2557a35b702525': `Zmienna`,
'sec2da4aa7a02b925': `Islandzki`,
'sec30fbb20f102670': `Wstaw podsumowanie`,
'sec8b0b6c729816b6': `Grupa nagłówkowa`,
'seccd05955adb76bc': `Plakat`,
'sed17285cd25d6389': `Katalog, w którym znajduje się plik package.json`,
'sed318ec045c5144f': `Odbiór`,
'sed713f1b916fb469': `Odstęp między krawędziami (x)`,
'sed74a31b9172942c': `Odstęp między krawędziami (y)`,
'sed86bd0deb2e5372': `Przekształcanie tekstu`,
'see2fcaedf9743ec6': `Lokalizacja`,
'seec6798afe90ffc8': `Drukuj`,
'sef00c258bc1ecf1e': `Ten eksplorator ma niezapisane zmiany.`,
'sef23dd271edd4a8b': `Lewy dolny róg`,
'sef24caccbd4645ef': `Elastyczne obkurczanie`,
'sef49aec68fd1dc66': `Nazwa`,
'sef73fe18e351eb35': `Słowa kluczowe`,
'sef75f458d77491af': `Grupa opcji`,
'sefcf950b3cc4fc3b': `Język`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Zawartość`,
'sf0cab2483f66aa2e': `Niestandardowe`,
'sf0e261e04eda82ff': `Wygląd`,
'sf1045382c1fd9a85': `Dokładne kolory druku`,
'sf14c35392ec7bf10': `Ta funkcja jest niedostępna w przeglądarce Firefox. Jest ona dostępna w przeglądarce Chrome lub Edge.`,
'sf14f9d5f9f6ca342': `Plus lżejszy`,
'sf1868dc19e3917bb': `Hiszpański`,
'sf190149f9d8bbb2a': `Tryb zapisu`,
'sf1e79171c4856543': `Czy na pewno? Tego działania nie można cofnąć, wszystkie ustawienia zostaną usunięte
          i zresetowane.`,
'sf21c1f60c7515f44': `Oznacz wybór jako przykładowe dane wyjściowe`,
'sf21fb4f4b9e8911f': `Szerokość`,
'sf22a3737146ec910': `WebWriter może osadzać SVG bezpośrednio w dokumencie.`,
'sf2514d5dc78b1654': `Wstaw widżet`,
'sf28903d4ca0ddcfc': `Usuń to konto`,
'sf2ab37af0abc55ef': `Ukryj wycieczkę wprowadzającą`,
'sf2bdb0b4d7b9c039': `Bengalski`,
'sf2cbb5e519264e67': `Zmiana rozmiaru zarówno w poziomie, jak i w pionie`,
'sf2d5cbc2fe0ad65a': `Lepki`,
'sf2d96d0eb32cb81f': `Kompozycja animacji`,
'sf2de3dbe2108637a': `Renderowanie kształtu`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Wstawianie ścieżki`,
'sf3c4da68b08a2590': `Madagaskar`,
'sf471ec2496f904cc': `Odrzuć zmiany`,
'sf4849bc200e279ed': `Podpis pod tabelą`,
'sf486ca1fdbe08645': `Wstaw rysunek`,
'sf4b537d4cbd8f5fd': `Tekst u góry`,
'sf4e0e02a5277ef23': `Wstaw obszar tekstowy`,
'sf4f067d41efd4b83': `Skala (y)`,
'sf4f3cbd41f002b46': `Skala (x)`,
'sf4fa67d41f05a008': `Skala (z)`,
'sf5197db2d5f2926a': `Obrót`,
'sf52d840949a980d1': str`
          ${0}
          zostaną trwale usunięte. Czy na pewno? 
        `,
'sf55d634dcc743595': `Usługi`,
'sf59c9081d106dd9c': `Oznacz wybór jako zmienną`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Usuwanie dokumentu`,
'sf65df67a03bebe4b': `Wymagane dla tego widżetu`,
'sf6673729c03ae999': `Reset WebWriter`,
'sf67571992e7dc88e': `Pełny okres`,
'sf6b4934598f7ed10': `Zezwalaj na wybór`,
'sf6e1665c7022a1f8': `Hasło`,
'sf79e0d78b56444f1': `Inline end`,
'sf7a5f7a7c80c3082': `Oba`,
'sf7c0eba7c822e3d6': `Pogrubienie`,
'sf86bd4d2982f3b74': `Oznacz wybór jako kod`,
'sf8e82313fa411494': `Oznacz zaznaczenie jako łącze`,
'sf955eff73fb6b573': `Serbski`,
'sf9929e2d356260c5': `Mnożenie`,
'sf993bb199fefbe04': `Wszystkie`,
'sf9ecf969dd4b8164': `Obie krawędzie`,
'sf9f2c719a04066ec': `Aplikacja`,
'sfa49a5bb1a5d353e': `Dostęp prywatny`,
'sfa59c7777e2a0eeb': `Wstawianie listy danych`,
'sfaa0a67db5c11f72': `Wcięcie pierwszego wiersza tekstu`,
'sfb231a52211b133f': `Brak zawijania tekstu`,
'sfb68cae41d749423': `Początkowy`,
'sfb9b6edb0ed378c9': `Źródło cytatu`,
'sfbbab09dbe553571': `Wstawianie rysunku wektorowego (SVG)`,
'sfc00292e778b67e2': `Miernik`,
'sfc63e31ac7c956ed': `Wybierz`,
'sfc815c9078bba30a': `Pobierz kod QR jako obraz`,
'sfcdd8e672c75b713': `Adres`,
'sfcebd18506f1e535': `Przepływ`,
'sfd0cde85070d2eb2': `Elastyczność`,
'sfd77270c3f54f664': `Wyjście`,
'sfdb1e4d90981a535': `Udostępnij ten dokument`,
'sfdeef3dccf409f81': `To słowo kluczowe jest wymagane dla widżetów`,
'sfe6e758ad2603c1d': `Magister`,
'sfee1c12daf838935': `Wypalanie kolorów`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Wstawianie okna dialogowego`,
'sffa395f64ec6ac36': `Bułgarski`,
'sffdadf0a576fd802': `Wysokość`,
'spaceKey': `Przestrzeń`,
'tabKey': `⭾ Tab`,
'upKey': `↑ W górę`,
    };
  